<head>
  <!-- Required meta tags -->
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">

  <!-- Bootstrap CSS -->
  <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/css/bootstrap.min.css"
    integrity="sha384-Vkoo8x4CGsO3+Hhxv8T/Q5PaXtkKtu6ug5TOeNV6gBiFeWPGFN9MuhOf23Q9Ifjh" crossorigin="anonymous">
</head>
<div class="container-fluid">
  <div class="row">
    <h5 class="border-bottom">Premium Transactions</h5>
    <nav class="navbar navbar-light bg-light justify-content-between">
      <a class="navbar-brand"></a>
      <div class="input-group search-style">
        <input  class="form-control mr-sm-1" type="search" [(ngModel)]="searchTerm" placeholder="Search">
        <div class="input-group-append">
          <button class="btn removefocus" type="button" (click)="search()" *ngIf="!isSearching">
            <i class="fa fa-search"></i>
          </button>
          <button class="btn removefocus" type="button" (click)="clearSearch()" *ngIf="isSearching">
            <i class="fa fa-times"></i>
          </button>

        </div>
      </div>
    </nav>

    <section class="table-container" [ngClass]="{ 'table-container-collapsed':!dynamicTabsService.isCollapsed}" tabindex="0">
      <table mat-table [dataSource]="dataSource" class="table table-bordered">
        <ng-container matColumnDef="masterPolicyNumber">
          <th mat-header-cell *matHeaderCellDef>
            <button class="btn btn-link" (click)="sortData('masterPolicyNumber')" matTooltip="Sort by Master Policy">
              Master Policy
              <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='masterPolicyNumber'"
                [class.fa-sort-asc]="sortingColumn ==='masterPolicyNumber' && sortOrder === 'asc'"
                [class.fa-sort-desc]="sortingColumn ==='masterPolicyNumber' && sortOrder === 'desc'"></i>
            </button>
          </th>
          <td mat-cell *matCellDef="let premium"><a (click)="openPolicy(premium)">{{premium.masterPolicyNumber}}</a>
          </td>
        </ng-container>
        <ng-container matColumnDef="memberPolicyNumber">
          <th mat-header-cell *matHeaderCellDef>
            <button class="btn btn-link" (click)="sortData('memberPolicyNumber')" matTooltip="Sort by Member Policy">
              Member Policy
              <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='memberPolicyNumber'"
                [class.fa-sort-asc]="sortingColumn ==='memberPolicyNumber' && sortOrder === 'asc'"
                [class.fa-sort-desc]="sortingColumn ==='memberPolicyNumber' && sortOrder === 'desc'"></i>
            </button>
          </th>
          <td mat-cell *matCellDef="let premium">{{ premium.memberPolicyNumber}}</td>
        </ng-container>
        <ng-container matColumnDef="transactionDate">
          <th mat-header-cell *matHeaderCellDef>
            <button class="btn btn-link" (click)="sortData('transactionDate')" matTooltip="Sort by Transaction Date">
              Transaction Date
              <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='transactionDate'"
                [class.fa-sort-asc]="sortingColumn ==='transactionDate' && sortOrder === 'asc'"
                [class.fa-sort-desc]="sortingColumn ==='transactionDate' && sortOrder === 'desc'"></i>
            </button>
          </th>

          <td mat-cell *matCellDef="let premium">{{ premium.transactionDate | date: 'MM/dd/yyyy'}}</td>
        </ng-container>
        <ng-container matColumnDef="transactionType">
          <th mat-header-cell *matHeaderCellDef>
            <button class="btn btn-link" (click)="sortData('transactionType')" matTooltip="Sort by Transaction Type">
              Transaction Type
              <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='transactionType'"
                [class.fa-sort-asc]="sortingColumn ==='transactionType' && sortOrder === 'asc'"
                [class.fa-sort-desc]="sortingColumn ==='transactionType' && sortOrder === 'desc'"></i>
            </button>
          </th>
          <td mat-cell *matCellDef="let premium">{{ premium.transactionType}}</td>
        </ng-container>
        <ng-container matColumnDef="insuredValueChange">
          <th mat-header-cell *matHeaderCellDef>
            <button class="btn btn-link" (click)="sortData('insuredValueChange')"
              matTooltip="Sort by Insured Value Change">
              Insured Value Change
              <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='insuredValueChange'"
                [class.fa-sort-asc]="sortingColumn ==='insuredValueChange' && sortOrder === 'asc'"
                [class.fa-sort-desc]="sortingColumn ==='insuredValueChange' && sortOrder === 'desc'"></i>
            </button>
          </th>
          <td mat-cell *matCellDef="let premium">{{ premium.insuredValueChange}}</td>
        </ng-container>
        <ng-container matColumnDef="premiumChange">
          <th mat-header-cell *matHeaderCellDef>
            <button class="btn btn-link" (click)="sortData('premiumChange')" matTooltip="Sort by Premium Change">
              Premium Change
              <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='premiumChange'"
                [class.fa-sort-asc]="sortingColumn ==='premiumChange' && sortOrder === 'asc'"
                [class.fa-sort-desc]="sortingColumn ==='premiumChange' && sortOrder === 'desc'"></i>
            </button>
          </th>
          <td mat-cell *matCellDef="let premium">{{ premium.premiumChange}}</td>
        </ng-container>
        <ng-container matColumnDef="empty">
          <th mat-header-cell *matHeaderCellDef class="myempty"></th>
          <td mat-cell *matCellDef="let empty"></td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columnsToDisplay;sticky: true"class="headerstyle"></tr>
        <tr mat-row *matRowDef="let premium; columns: columnsToDisplay"></tr>
      </table>
    </section>

    <!-- Pagination -->
    <div>
      <mat-paginator class="pagination" [length]="totalItems" [hidePageSize]="isHidePageSize"
      [showFirstLastButtons]="showFirstLastButtons" (page)="onPageChange($event)" aria-label="Select page">
      </mat-paginator>
    </div>
  </div>
     <!-- Table spinner -->
     <div *ngIf="isLoading" class="spinner-wrapper">
      <mat-spinner diameter="32" color="primary"></mat-spinner>
    </div>
</div>